import type { EventType, AlertStatus } from "../types/events";

interface EventColorSet {
  main: string;
  light: string;
  border: string;
  dark: string;
}

export const EVENT_COLORS: Record<EventType, EventColorSet> = {
  alert: {
    main: "#F44336",
    light: "#FFEBEE",
    border: "#EF9A9A",
    dark: "#C62828",
  },
  forbidden_zone: {
    main: "#FF9800",
    light: "#FFF3E0",
    border: "#FFCC80",
    dark: "#E65100",
  },
  journey: {
    main: "#2196F3",
    light: "#E3F2FD",
    border: "#90CAF9",
    dark: "#1565C0",
  },
};

export const ALERT_STATUS_COLORS: Record<AlertStatus, string> = {
  NEW: "#2196F3",
  ACCEPTED: "#FF9800",
  CALLED: "#9C27B0",
  CLOSED: "#4CAF50",
};

// Helper: get chip sx props for an event type
export function getEventChipColor(eventType: EventType) {
  const c = EVENT_COLORS[eventType];
  return {
    backgroundColor: c.light,
    color: c.dark,
    borderColor: c.border,
    border: "1px solid",
  } as const;
}

// Helper: get card border sx for an event type
export function getEventCardBorderSx(eventType: EventType) {
  const c = EVENT_COLORS[eventType];
  return {
    borderLeft: `4px solid ${c.main}`,
  } as const;
}

// Helper: get timeline dot color for an event type
export function getTimelineDotColor(eventType: EventType) {
  return EVENT_COLORS[eventType].main;
}

// Helper: get alert status chip sx
export function getAlertStatusChipSx(status: AlertStatus) {
  const color = ALERT_STATUS_COLORS[status];
  return {
    backgroundColor: `${color}20`,
    color,
    fontWeight: 600,
  } as const;
}
